module.exports = __webpack_public_path__ + "25423f480de9012f09ce8892c8f9a891.svg";